import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Collapsible = ({
  id,
  expanded = false,
  buttonClassName,
  buttonText,
  buttonProps = {},
  expandedButtonText,
  wrapperClassName,
  headerClassName,
  contentClassName,
  children,
}) => {
  const collapseRef = useRef(null);
  const [isOpen, setIsOpen] = useState(expanded);

  const contentId = `collapsible-content--${id}`;
  const controlId = `collapsible-control--${id}`;

  useEffect(() => {
    const $collapseEl = window.$(collapseRef.current);

    const handleShow = () => setIsOpen(true);
    const handleHide = () => setIsOpen(false);

    $collapseEl.on('show.bs.collapse', handleShow);
    $collapseEl.on('hide.bs.collapse', handleHide);

    if (expanded) {
      $collapseEl.addClass('show');
    }

    return () => {
      $collapseEl.off('show.bs.collapse', handleShow);
      $collapseEl.off('hide.bs.collapse', handleHide);
    };
  }, [expanded]);

  const toggleCollapse = () => {
    window.$(collapseRef.current).collapse('toggle');
  };

  return (
    <div
      id={`collapsible--${id}`}
      className={classNames('collapsible', wrapperClassName)}>
      <div className={classNames('collapsible__header', headerClassName)}>
        <button
          id={controlId}
          className={classNames('btn', buttonClassName)}
          type="button"
          onClick={toggleCollapse}
          aria-controls={id}
          aria-expanded={isOpen}
          {...buttonProps}>
          {isOpen ? expandedButtonText || buttonText : buttonText}
          <i
            className={`ml-2 fas fa-chevron-${isOpen ? 'up' : 'down'}`}
            aria-hidden="true"
          />
        </button>
      </div>

      <div
        className={classNames(
          'collapse collapsible__content',
          contentClassName,
        )}
        id={contentId}
        aria-labelledby={controlId}
        ref={collapseRef}>
        {children}
      </div>
    </div>
  );
};

Collapsible.propTypes = {
  id: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  expandedButtonText: PropTypes.string,
  buttonClassName: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  wrapperClassName: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  headerClassName: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  contentClassName: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.arrayOf(
      PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element,
        PropTypes.arrayOf(PropTypes.element),
      ]),
    ),
  ]).isRequired,
  buttonProps: PropTypes.object,
  expanded: PropTypes.bool,
};

export { Collapsible };
